<template>
<div>
  <v-card :loading="loading" class="rounded-lg elevation-0">
    <slot name='title' :records='records' :total='page.total' :loading='loading'></slot>
  </v-card>
  <div class="my-3">
    <slot name='content' :records='records' :loading='loading'></slot>
  </div>
  <v-card-text class="white pa-6 my-5 rounded-lg">
    <div v-if="!$isMobile" class="mt-n2 float-left">
      <v-text-field
        outlined
        dense
        style="width:170px;height:30px"
        hide-details
        v-model="skipPage"
        @keydown="queryKeyDown()"
        type="number"
        prefix="跳转至["
        suffix="]页"
      ></v-text-field>
    </div>
    <v-row align="center" justify="end">
      <div class="grey--text">共 {{page.total}} 条</div>
      <v-pagination
        justify="space-around"
        :total-visible="7"
        v-model="page.current"
        :length="page.count"
        @input="nextPage"
      ></v-pagination>
    </v-row>
  </v-card-text>
  <v-dialog v-model="delDialog" max-width="320">
    <v-card>
      <v-card-title class="text-h6">
        <v-icon color="warning">mdi-alert</v-icon>&nbsp;
        系统提示
      </v-card-title>
      <v-card-text>
        <div class="text-h6 pa-2">确定执行删除操作吗？</div>
      </v-card-text>
      <v-card-actions class="justify-end p4-1">
        <v-btn text small color="blue" @click="delDialog = false">取消</v-btn>
        <v-btn color="primary" :loading="deleteLoading" depressed small @click="deleted">
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
  import { list, remove } from '@/api/data.js'
  import { isEmpty } from '@/utils/stringUtil.js'

  export default {
    name: 'CardListIndex',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          height: 200,
          path: '',
          topButtons: [],
          sort: null,
          params: {},
          records: null,
          pageSize: 12
        })
      },
      lazy: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        records: [],
        skipPage: '',
        page: {
          total: 0,
          count: 0,
          current: 1,
          orderByField: 'id',
          asc: false
        },
        loading: false,
        delDialog: false,
        deleteLoading: false
      }
    },
    methods: {
      loadData () {
        this.$emit('on-load')
        if (this.item.records) {
          this.records = this.item.records
        } else {
          this.loading = true
          Object.assign(this.pageParams, this.item.params)
          list(this.item.path, this.pageParams).then(res => {
            if (res.status === 200) {
              this.page.count = res.data.pages
              this.page.current = res.data.current
              this.page.total = res.data.total
              this.records = res.data.records
            }
            this.loading = false
          })
        }
      },
      doDelete (item) {
        this.delDialog = true
        this.row = item
      },
      deleted () {
        this.deleteLoading = true
        remove(this.item.path.replace('list', 'delete'), this.row.id).then(res => {
          if (res.status === 200) {
            this.delDialog = false
            this.loadData()
            this.$emit("on-delete-success")
            this.$dialog.notify.success('数据操作成功！', { position: 'top-right', timeout: 3000 })
          }
          this.deleteLoading = false
        })
      },
      nextPage (current) {
        this.page.current = current
        this.loadData()
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.page.current = Number(this.skipPage) || 1
          this.loadData()
        }
      }
    },
    computed: {
      pageParams () {
        return {
          page: {
            current: this.page.current,
            size: this.item.pageSize || 12,
            asc: this.page.asc,
            orderByField: this.page.orderByField
          }
        }
      }
    },
    created() {
      if (!isEmpty(this.item.sort)) {
        this.page.orderByField = this.item.sort.orderByField
        this.page.asc = this.item.sort.asc || false
      }
      if (!this.lazy) {
        this.loadData()
      }
    }
  }
</script>

<style>
.sub-btns{
  position: absolute;
  bottom: 1px;
  right: 1px;
}
.order-address, .order-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
